import { AddFarmData, GetAssignedFarmUsersData, GetFarmData, GetProdPlacesByFarmData } from "types";
import { service } from ".";
import { cookies } from 'static';
import { ApiError } from './errorTypes';

const SELF_ADD_FARM_TIMEOUT_MS = 180000;

const getToken = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  return stored ? JSON.parse(stored)?.token : undefined;
};

export const addFarmInfo = (farmData: AddFarmData) => service('/api/v1/farms/self-add', {method: 'POST', data: farmData}, getToken());

export const getFarmInfo = (params: {id: number | string}): Promise<GetFarmData> => service('/api/v1/farms/get', {method: 'GET', params}, getToken()) as Promise<GetFarmData>;

export const getAssignedFarmUsers = (params: {id: number | string}): Promise<GetAssignedFarmUsersData> =>
  service(
    '/api/v1/farms/get-assigned-users',
    { method: 'GET', params, suppressErrorToast: true } as Parameters<typeof service>[1],
    getToken(),
  ) as Promise<GetAssignedFarmUsersData>;

export const getProdPlacesByFarm = (params: {farmId: number | string}): Promise<GetProdPlacesByFarmData> =>
  service('/api/v1/prod-places/get-by-farm', { method: 'GET', params }, getToken()) as Promise<GetProdPlacesByFarmData>;

const extractSelfAddFarmPayload = (error: unknown) => {
  if (!(error instanceof ApiError)) {
    return null;
  }

  const payload = error.originalError?.response?.data?.payload;

  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const farmId = (payload as { id?: string | number; farmId?: string | number }).id
    ?? (payload as { id?: string | number; farmId?: string | number }).farmId;

  return farmId != null && `${farmId}`.length > 0 ? payload : null;
};

export const selfAddFarm = async (params: any) => {
  try {
    return await service(
      '/api/v1/farms/self-add',
      {
        method: 'POST',
        data: params,
        timeout: SELF_ADD_FARM_TIMEOUT_MS,
        suppressErrorToast: true,
      } as any,
      getToken(),
    );
  } catch (error) {
    const payload = extractSelfAddFarmPayload(error);

    if (payload) {
      return payload;
    }

    throw error;
  }
};

export const selfSyncFarmToCrops = (farmId: string | number) =>
  service('/api/v1/farms/self-sync-crops', { method: 'POST', params: { farmId }, timeout: 180000, suppressErrorToast: true } as any, getToken());

export const selfAddProdPlace = (params: any) => service('/api/v1/prod-places/self-add', {method: 'POST', data: params}, getToken());

export const updateFarm = (params: any) => service('/api/v1/farms/admin-edit', {method: 'PUT', data: params}, getToken());

const getInviteFarmUsersParams = (userEmails: string[]) => ({
  'userEmails[]': userEmails,
});

export const inviteFarmUsers = (userEmails: string[]) =>
  service(
    '/api/v1/farms/invite-users',
    {
      method: 'POST',
      params: getInviteFarmUsersParams(userEmails),
    },
    getToken(),
  );
